import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

const PROXY_SECRET_HEADER = 'x-cie-proxy-secret';

/**
 * Server side only (provided in AppServerModule). Marks the API requests made while rendering a page
 * for a crawler as this server's own, so the API does not rate limit them as if all crawlers were one
 * client. STOREFRONT_PROXY_SECRET must match the API's.
 */
export const proxySecretHttpInterceptor: HttpInterceptorFn = (req, next) => {
  const secret = (globalThis as any).process?.env?.STOREFRONT_PROXY_SECRET;
  // AppConfig is provided per render, so this follows the API the page talks to (the marketplace
  // picks the API domain from the page's country).
  const appConfig = inject('AppConfig' as any) as any;
  const apiHosts = Object.values(appConfig.api || {})
    .map((entry: any) => entry && entry.host)
    .filter((host) => typeof host === 'string' && /^https?:\/\//.test(host));

  if (!secret || !apiHosts.some((host) => req.url.startsWith(host))) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { [PROXY_SECRET_HEADER]: secret } }));
};
